module.exports = __webpack_public_path__ + "img/pIndex-dialog-ins.e17e866d.png";